import React, { Suspense } from 'react';
import Login from 'pages/login/Login';
import NotFound from 'components/404';
import Loader from 'wrapper/loader';

const Documents = React.lazy(() => import('pages/documents'));
const Tools = React.lazy(() => import('pages/tools'));
const Profile = React.lazy(() => import('pages/profile'));
const Pipeline = React.lazy(() => import('pages/pipeline'));
const Onboarding = React.lazy(() => import('pages/onboarding/Onboarding'));
const Dashboard = React.lazy(() => import('pages/dashboard'));
const ConsumerOnboard = React.lazy(() => import('pages/auth/ConsumerOnboard'));

const consumerRoutes = [
  {
    path: '/',
    element: <Login />,
    children: [
      {
        path: 'documents',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <Documents />
          </Suspense>
        ),
      },
      {
        path: 'tools',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <Tools />
          </Suspense>
        ),
      },
      {
        path: 'onboarding',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <Onboarding />
          </Suspense>
        ),
      },
      {
        path: 'onboard',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <ConsumerOnboard />
          </Suspense>
        ),
      },
      {
        path: 'dashboard',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <Dashboard />
          </Suspense>
        ),
      },
      {
        path: 'profile',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <Profile />
          </Suspense>
        ),
      },
      {
        path: 'pipeline',
        element: (
          <Suspense fallback={<Loader variant="gray" FullScreen={true} />}>
            <Pipeline />
          </Suspense>
        ),
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
];

export default consumerRoutes;
